import { Box, Typography, TextField } from "@mui/material";

const TextAreaLine = ({
                          label,
                          name,
                          value,
                          onChange,
                          onBlur,
                          required = false,
                          rows = 6,
                          error,
                          helperText,
                      }) => {
    return (
        <Box sx={{ mb: 4, maxWidth: 900 }}>
            <Typography
                sx={{
                    fontSize: 16,
                    color: error ? "#d32f2f" : "#004B88",
                    mb: 1,
                    fontWeight: 400,
                }}
            >
                {label}
                {required && (
                    <span style={{ color: error ? "#d32f2f" : "#004B88" }}>*</span>
                )}
            </Typography>
            <TextField
                name={name}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                multiline
                rows={rows}
                fullWidth
                error={Boolean(error)}
                helperText={error ? helperText : ""}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        borderRadius: 0,
                        background: "transparent",
                        color: "#004B88",
                        "& fieldset": {
                            borderColor: error ? "#d32f2f" : "#004B88",
                        },
                        "&:hover fieldset": {
                            borderColor: error ? "#d32f2f" : "#004B88",
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: error ? "#d32f2f" : "#004B88",
                        },
                    },
                    "& .MuiFormHelperText-root": {
                        color: "#d32f2f",
                        mt: "4px",
                    }
                }}
            />
        </Box>
    );
};

export default TextAreaLine;
